<mat-toolbar>
  <mat-toolbar-row>
    <ng-container class="mat-toolbar__left">
      @if (flocks().length > 0) {
        <div class="flex--column spacing--margin-right item-selector">
          <mat-select
            [hideSingleSelectionIndicator]="true"
            class="text--small mat-select-large"
            placeholder="{{ 'flock-overview.placeholder' | translate }}"
            data-test="flock-overview__flock-selector"
            [(ngModel)]="selectedFlockId"
            (selectionChange)="changeFlockSelection($event)"
          >
            <mat-select-trigger>
              @if (selectedFlock; as selectedFlock) {
                <span>
                  <span class="text--body">
                    {{ selectedFlock.name }}
                    <br />
                  </span>
                  <span>
                    {{ 'flock-overview.selector-option-barn' | translate }}
                    {{ selectedFlock.arrival?.barn?.name }} -
                    {{ selectedFlock.arrival?.arrivalDate | agrDate: 'shortDate' }}
                  </span>
                </span>
              }
            </mat-select-trigger>
            @for (flock of flocks(); track flock.id) {
              <mat-option [value]="flock.id">
                {{ flock.name }} - {{ 'flock-overview.selector-option-barn' | translate }}
                {{ flock.arrival?.barn?.name }} -
                {{ flock.arrival?.arrivalDate | agrDate: 'shortDate' }}
              </mat-option>
            }
          </mat-select>
        </div>
      }
    </ng-container>

    <div class="mat-toolbar__right">
      @if (selectedFlock && !isMobile() && config().showLayerActions) {
        <app-feed-balance-action [flockId]="selectedFlock.id" />
      }
      @if (!isMobile() && selectedFlock; as selectedFlock) {
        <button
          class="margin-right"
          mat-flat-button
          (click)="deleteFlock(selectedFlock)"
          data-test="flock-overview__delete-flock"
        >
          <mat-icon>delete</mat-icon>{{ config().deleteFlockTranslationKey | translate }}
        </button>
      }

      @if (!isMobile()) {
        <button
          class="margin-right"
          mat-flat-button
          (click)="openFlockDetail()"
          data-test="flock-overview__new-flock"
        >
          <mat-icon>add</mat-icon>{{ config().newFlockTranslationKey | translate }}
        </button>
      }

      @if (!isMobile() && selectedFlock && hasWeekRegistrationActions()) {
        <button
          mat-flat-button
          color="accent"
          class="margin-right"
          (click)="addOrEditWeek()"
          data-test="flock-overview__add-week"
          [disabled]="!canAddWeek()"
        >
          <mat-icon>add</mat-icon>{{ 'flock-overview.add-week' | translate }}
        </button>
      }

      @if (selectedFlock && !isMobile() && config().showLayerActions) {
        <button
          mat-flat-button
          [matMenuTriggerFor]="downloadMenu"
          data-test="flock-overview__download-pdf"
        >
          <mat-icon>print</mat-icon><mat-icon>arrow_drop_down</mat-icon>
        </button>
      }

      @if (isMobile()) {
        <div class="float-right">
          <button mat-icon-button [matMenuTriggerFor]="mobileMenu">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #mobileMenu="matMenu">
            @if (selectedFlock && config().showLayerActions) {
              <app-feed-balance-action [flockId]="selectedFlock.id" [mobile]="true" />
            }
            @if (selectedFlock && config().showLayerActions) {
              <button
                mat-menu-item
                [matMenuTriggerFor]="downloadMenu"
                data-test="flock-overview__download-pdf"
              >
                <mat-icon>print</mat-icon>
                {{ 'flock-overview.print' | translate }}
              </button>
            }

            @if (selectedFlock; as selectedFlock) {
              <button
                mat-menu-item
                (click)="deleteFlock(selectedFlock)"
                data-test="flock-overview__delete-flock"
              >
                <mat-icon>delete</mat-icon>
                {{ config().deleteFlockTranslationKey | translate }}
              </button>
            }

            <button mat-menu-item (click)="openFlockDetail()" data-test="flock-overview__new-flock">
              <mat-icon>add_circle</mat-icon>
              {{ config().newFlockTranslationKey | translate }}
            </button>

            @if (selectedFlock && hasWeekRegistrationActions()) {
              <button
                mat-menu-item
                (click)="addOrEditWeek()"
                [disabled]="!canAddWeek()"
                data-test="flock-overview__add-week"
              >
                <mat-icon>view_comfy</mat-icon>
                {{ 'flock-overview.add-week' | translate }}
              </button>
            }
          </mat-menu>
        </div>
      }

      <mat-menu #downloadMenu>
        <button
          mat-menu-item
          (click)="downloadPdf('flock-report')"
          data-test="flock-overview__download-flock-report-button"
        >
          <mat-icon>leaderboard</mat-icon>
          <span>{{ 'flock-overview.download-all' | translate }}</span>
        </button>
        <button
          mat-menu-item
          (click)="downloadPdf('animalcount-report')"
          data-test="flock-overview__download-animalcount-report-button"
        >
          <mat-icon>leaderboard</mat-icon>
          <span>{{ 'flock-overview.download-animal-count' | translate }}</span>
        </button>
      </mat-menu>
    </div>
  </mat-toolbar-row>
</mat-toolbar>

@if (selectedFlock; as selectedFlock) {
  <div>
    <app-flock-overview-panel
      [title]="'flock-overview.panel.arrival-title' | translate"
      [isEmpty]="selectedFlock === undefined"
      [emptyMessage]="'flock-overview.panel.emptymessage-arrival' | translate"
      [isMobile]="isMobile()"
      [showBottomBar]="selectedFlock === undefined"
      [actionTitle]="'flock-overview.panel.edit-arrival' | translate"
      (actionClicked)="openFlockDetail(selectedFlock)"
    >
      <div body>
        <div [class.arrival-scroll-container]="config().showBreederFields">
          <div
            class="flex--row flex--nowrap"
            [class.arrival-scroll-content]="config().showBreederFields"
          >
            @if (!isMobile()) {
              <div class="flex--column layout--padding-right min-column-width-110">
                @if (!config().showBreederFields) {
                  <div class="text--small text--gray">
                    {{ 'flock-overview.panel.egg-marketing-standard' | translate }}
                  </div>
                  <div data-test="flock-overview__marketing-standard">
                    {{ selectedFlock.arrival?.eggMarketingStandard }} -
                    {{ getMarketingStandard(selectedFlock.arrival?.eggMarketingStandard) }}
                  </div>
                } @else {
                  <div class="text--small text--gray">
                    {{ 'flock-overview.panel.hatchery-name' | translate }}
                  </div>
                  <div data-test="flock-overview__hatchery">
                    {{ displayValue(selectedFlock.arrival?.hatchery?.name) }}
                  </div>
                }
              </div>
            }

            @if (!isMobile() && !config().showBreederFields) {
              <div class="flex--column layout--padding-right min-column-width-110">
                <div class="text--small text--gray">
                  {{ 'flock-overview.panel.housing-system' | translate }}
                </div>
                <div data-test="flock-overview__housing-system">
                  @if (selectedFlock.arrival?.housingSystem != null) {
                    {{ selectedFlock.arrival?.housingSystem }} -
                    {{ getHousingSystem(selectedFlock.arrival?.housingSystem) }}
                  } @else {
                    {{ displayValue(selectedFlock.arrival?.housingSystem) }}
                  }
                </div>
              </div>
            }

            @if (!isMobile() && !config().showBreederFields) {
              <div class="flex--column layout--padding-right min-column-width-110">
                <div class="text--small text--gray">
                  {{ 'flock-overview.panel.hatchery-name' | translate }}
                </div>
                <div data-test="flock-overview__hatchery">
                  {{ displayValue(selectedFlock.arrival?.hatchery?.name) }}
                </div>
              </div>
            }

            <div class="flex--column layout--padding-right min-column-width-60">
              <div class="text--small text--gray">
                {{ 'flock-overview.panel.amount-of-hens' | translate }}
              </div>
              <div data-test="flock-overview__amount-of-hens">
                {{ selectedFlock.arrival?.amountOfHens }}
              </div>
            </div>

            @if (config().showBreederFields) {
              <div class="flex--column layout--padding-right min-column-width-60">
                <div class="text--small text--gray">
                  {{ 'flock-overview.panel.amount-of-roosters' | translate }}
                </div>
                <div data-test="flock-overview__amount-of-roosters">
                  {{ displayValue(selectedFlock.arrival?.amountOfRoosters) }}
                </div>
              </div>
            }

            <div class="flex--column layout--padding-right min-column-width-110">
              <div class="text--small text--gray">
                {{ 'flock-overview.panel.breed-name' | translate }}
              </div>
              <div data-test="flock-overview__breed">
                {{ displayValue(selectedFlock.arrival?.breed?.name) }}
              </div>
            </div>

            @if (!isMobile()) {
              <div class="flex--column layout--padding-right min-column-width-110">
                <div class="text--small text--gray">
                  {{ 'flock-overview.panel.barn-name' | translate }}
                </div>
                <div data-test="flock-overview__barn">
                  {{ displayValue(selectedFlock.arrival?.barn?.name) }}
                </div>
              </div>
            }

            @if (!isMobile()) {
              <div class="flex--column layout--padding-right min-column-width-110">
                <div class="text--small text--gray">
                  {{ 'flock-overview.panel.chick-birthdate' | translate }}
                </div>
                <div data-test="flock-overview__chick-birth-date">
                  {{ selectedFlock.arrival?.chickBirthDate | agrDate: 'shortDate' }}
                </div>
              </div>
            }

            <div class="flex--column layout--padding-right min-column-width-110">
              <div class="text--small text--gray">
                {{ 'flock-overview.panel.arrival-date' | translate }}
              </div>
              <div data-test="flock-overview__chick-arrival-date">
                {{ selectedFlock.arrival?.arrivalDate | agrDate: 'shortDate' }}
              </div>
            </div>

            @if (config().showBreederFields) {
              <div class="flex--column layout--padding-right min-column-width-110">
                <div class="text--small text--gray">
                  {{ 'flock-overview.panel.feed-system-hens' | translate }}
                </div>
                <div data-test="flock-overview__feed-system-hens">
                  {{
                    displayValue(
                      getLookupLabel('feed-systems', selectedFlock.arrival?.feedSystemHens)
                    )
                  }}
                </div>
              </div>
            }

            @if (config().showBreederFields) {
              <div class="flex--column layout--padding-right min-column-width-110">
                <div class="text--small text--gray">
                  {{ 'flock-overview.panel.hen-weight' | translate }}
                </div>
                <div data-test="flock-overview__hen-weight">
                  {{ displayValue(selectedFlock.arrival?.henWeightInGrams) }}
                </div>
              </div>
            }

            @if (
              config().showBreederFields && hasRoosters(selectedFlock.arrival?.amountOfRoosters)
            ) {
              <div class="flex--column layout--padding-right min-column-width-110">
                <div class="text--small text--gray">
                  {{ 'flock-overview.panel.rooster-weight' | translate }}
                </div>
                <div data-test="flock-overview__rooster-weight">
                  {{ displayValue(selectedFlock.arrival?.roosterWeightInGrams) }}
                </div>
              </div>
            }

            @if (
              config().showBreederFields && hasRoosters(selectedFlock.arrival?.amountOfRoosters)
            ) {
              <div class="flex--column layout--padding-right min-column-width-110">
                <div class="text--small text--gray">
                  {{ 'flock-overview.panel.feed-system-roosters' | translate }}
                </div>
                <div data-test="flock-overview__feed-system-roosters">
                  {{
                    displayValue(
                      getLookupLabel('feed-systems', selectedFlock.arrival?.feedSystemRoosters)
                    )
                  }}
                </div>
              </div>
            }

            @if (config().showBreederFields) {
              <div class="flex--column layout--padding-right min-column-width-110">
                <div class="text--small text--gray">
                  {{ 'flock-overview.panel.drink-system' | translate }}
                </div>
                <div data-test="flock-overview__drink-system">
                  {{
                    displayValue(
                      getLookupLabel('drink-systems', selectedFlock.arrival?.drinkSystem)
                    )
                  }}
                </div>
              </div>
            }

            @if (config().showBreederFields) {
              <div class="flex--column layout--padding-right min-column-width-110">
                <div class="text--small text--gray">
                  {{ 'flock-overview.panel.nest' | translate }}
                </div>
                <div data-test="flock-overview__nest">
                  {{ displayValue(getLookupLabel('nests', selectedFlock.arrival?.nest)) }}
                </div>
              </div>
            }

            @if (config().showBreederFields) {
              <div class="flex--column layout--padding-right min-column-width-110">
                <div class="text--small text--gray">
                  {{ 'flock-overview.panel.rearing-organization' | translate }}
                </div>
                <div data-test="flock-overview__rearing-organization">
                  {{ displayValue(selectedFlock.arrival?.rearingOrganization?.name) }}
                </div>
              </div>
            }

            @if (config().showBreederFields) {
              <div class="flex--column layout--padding-right min-column-width-110">
                <div class="text--small text--gray">
                  {{ 'flock-overview.panel.transport-distance' | translate }}
                </div>
                <div data-test="flock-overview__transport-distance">
                  {{ displayValue(selectedFlock.arrival?.transportDistance) }}
                </div>
              </div>
            }
          </div>
        </div>
      </div>

      <div bottom-bar>
        @if (selectedFlock === undefined) {
          <a mat-stroked-button color="primary" (click)="openFlockDetail()">
            <mat-icon>add</mat-icon>{{ 'flock-overview.panel.add-arrival' | translate }}
          </a>
        }
      </div>
    </app-flock-overview-panel>

    @if (hasWeekRegistrationActions()) {
      <app-flock-overview-panel
        [title]="'flock-overview.panel.weekregistrations-title' | translate"
        [isEmpty]="selectedFlock === undefined || !selectedFlockWeekData()?.data?.length"
        [emptyMessage]="'flock-overview.panel.emptymessage-weekregistrations' | translate"
        [isMobile]="isMobile()"
        [showBottomBar]="false"
      >
        <div body>
          <app-flock-overview-week-registration
            data-test="flock-overview-week-registration__component"
            [flock]="selectedFlock"
            [flockVariant]="config().flockVariant"
            (editClicked)="addOrEditWeek($event)"
            (deleteClicked)="deleteWeek($event)"
            [sortBy]="weekRegistrationSortBy"
            (sortByChanged)="onWeekRegistrationSortByChanged($event)"
            [isMobile]="isMobile()"
            [isLtLgBreakpoint]="isLtLgBreakpoint()"
          >
          </app-flock-overview-week-registration>
        </div>
      </app-flock-overview-panel>
    }

    @if (config().showLayerActions) {
      <app-flock-overview-panel
        [title]="'flock-overview.panel.departure-title' | translate"
        [isEmpty]="!selectedFlock.departure"
        [emptyMessage]="'flock-overview.panel.emptymessage-departure' | translate"
        [isMobile]="isMobile()"
        [showBottomBar]="true"
        [actionTitle]="'flock-overview.panel.edit-departure' | translate"
        (actionClicked)="updateDeparture()"
      >
        <div body>
          <div class="flex--row flex--nowrap">
            <div class="flex--column layout--padding-right min-column-width-110">
              <div class="text--small text--gray">
                {{ 'flock-overview.panel.departure-date' | translate }}
              </div>
              <div data-test="flock-overview__departure-date">
                {{ selectedFlock.departure?.departureDate | agrDate: 'shortDate' }}
              </div>
            </div>
            <div class="flex--column layout--padding-right min-column-width-60">
              <div class="text--small text--gray">
                {{ 'flock-overview.panel.departure-amount' | translate }}
              </div>
              <div data-test="flock-overview__departure-amount">
                {{ selectedFlock.departure?.amount }}
              </div>
            </div>
            <div class="flex--column layout--padding-right min-column-width-60">
              <div class="text--small text--gray">
                {{ 'flock-overview.panel.departure-weight' | translate }}
              </div>
              <div data-test="flock-overview__departure-weight">
                {{ selectedFlock.departure?.weightInGrams }}
              </div>
            </div>
          </div>
        </div>

        <div bottom-bar>
          @if (!selectedFlock.departure) {
            <button mat-stroked-button color="primary" (click)="updateDeparture()">
              <mat-icon>add</mat-icon>{{ 'flock-overview.panel.add-departure' | translate }}
            </button>
          }
        </div>
      </app-flock-overview-panel>
    }
  </div>
}

<agr-notification-empty
  [isEmpty]="flocks().length === 0"
  [emptyTitle]="'flock-overview.no-flocks.title' | translate"
  [emptyDescription]="'flock-overview.no-flocks.description' | translate"
  emptyImage="assets/images/arrival.jpg"
>
</agr-notification-empty>
